import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DowngradeEntitlement } from '@app/shared/+state/billing/billing.models';
import { EntitlementEnum } from '@app/shared/interfaces';

@Component({
  standalone: false,
  selector: 'sbnb-downgrade-warning',
  templateUrl: './downgrade-warning.component.html',
  styles: [
    `
      :host {
        display: contents;
      }

      .downgrade-warning {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DowngradeWarningComponent implements OnInit {
  @Input() entitlement: DowngradeEntitlement;
  @Input() hideIcon = false;

  public entitlements = EntitlementEnum;
  constructor() { }

  ngOnInit(): void { }
}
